// extracted by mini-css-extract-plugin
export default {"submenu":"styles_submenu__imliJ","active":"styles_active__bpOoh"};